import type { PasswordResetFormSchema } from '@/modules/passwordReset/components/PasswordResetForm/PasswordResetForm.types'

export const passwordResetFormDefaultValues: PasswordResetFormSchema = {
  email: '',
}
